/**
---
title: Icon
...

# Icon

## Properties
icon = "string"
extraClasses = "string"

## Variations (add as extraClasses)
icon--circled
icon--2x


## Notes
the 'icon' classes will automatically be prefixed... so all you need to do is add the specific part of the icon name you want
e.g. `icon="image"`  NOT   `icon="icon--image"` or `icon="icon icon--image"`

## Examples / Usage

basic:
`<Icon icon="image"/>`

circled:
`<Icon icon="image" extraClasses="icon--circled"/>`

**/

import PropTypes from "prop-types"
import React, { Component, Children } from "react"

export default class Icon extends Component {
  render() {
    const { extraClasses, children, icon, color, style, ...other } = this.props

    const classNames = "icon icon--" + icon

    const newStyles = {
      ...style
    }

    if (color) {
      newStyles.color = color
    }

    //Todo
    const extras = extraClasses ? extraClasses : ""

    return (
      <i {...other} className={classNames + " " + extras} style={newStyles}>
        {Children.forEach(children)}
      </i>
    )
  }
}

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  extraClasses: PropTypes.string
}



// WEBPACK FOOTER //
// ./webapp/components/elements/Icon.js